
export default function CTASection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full h-auto min-h-[400px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fb7144d4c0c2e03ba27c2674020556c4.jpg"
          alt="Alpine Sunset"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between px-6 md:px-12 lg:px-24 py-14 md:py-20 gap-10 md:gap-0">
        {/* Main Headline */}
        <div className="max-w-3xl">
          <h2
            className="text-4xl md:text-5xl lg:text-7xl font-bold text-white tracking-wide"
            style={{ letterSpacing: '2px' }}
          >
            BOOK YOUR
            <br />
            ALPINE ESCAPE
          </h2>
        </div>

        {/* Bottom Content */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          {/* CTA Button */}
          <button
            onClick={scrollToContact}
            className="group flex items-center gap-4 bg-white text-black px-8 md:px-12 py-5 md:py-6 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap self-start"
          >
            <span className="text-lg md:text-xl font-light tracking-wide">Reserve Now</span>
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-black text-white group-hover:bg-gray-800 transition-colors">
              <i className="ri-arrow-right-line text-xl"></i>
            </div>
          </button>

          {/* Supporting Text */}
          <div className="md:text-right max-w-xl">
            <p className="text-lg md:text-xl font-light text-white leading-relaxed mb-1">
              Experience luxury in the heart of
            </p>
            <p className="text-lg md:text-xl font-light text-white leading-relaxed">
              the French Alps. Your mountain retreat awaits.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
